import React, { useRef } from "react";
import lock from "../../assets/images/lock.png";
import email from "../../assets/images/email.png";
import PasswordField from "../common/PasswordField";

export function PasswordResetForm(props) {
	const instanceRef = useRef({ props });
	instanceRef.current.props = props;
	initialConstruct.bind(instanceRef.current)("VerifyOtpForm", props);

	const { validate, submit, formref, store } = props;

	return (
		<form ref={formref} className="popuplogin" onSubmit={(e) => submit(e)}>
			<div className="title">Enter New Password</div>
			<div className="form-input">
				<img src={lock} className="icon" />
				<PasswordField
					className="input"
					placeholder="New Password"
					name="password"
					onChange={(e) => validate(e, "password", formref.current)}
					required
				/>
			</div>
			<div className="form-input">
				<img src={lock} className="icon" />
				<PasswordField
					className="input"
					placeholder="Confirm Password"
					onChange={(e) => validate(e, "confirm_password", formref.current)}
					required
				/>
			</div>
			<div className="form-input">
				<span style={{ fontWeight: "bold", color: "red", fontSize: "10px" }}>
					{store.errorMsg}
					<br />
					{store.failureMsg}
				</span>
			</div>
			<div className="form-input">
				{!store.errorMsg && (
					<button type="submit" className="button" id="reset">
						Submit
					</button>
				)}
			</div>
		</form>
	);
}

export default PasswordResetForm;
